import { useTranslation } from 'react-i18next'
import { FormInput } from '@microservices/wiskey-react-components'

import { GENERATOR_INPUT_TYPE } from '@constants'
import { AutocompleteOption } from '@types'

type BindTypeCellProps = {
  fieldName: string
  isDisabled?: boolean
  options: AutocompleteOption[]
  isRequired?: boolean
}

export const BindTypeCell = ({ fieldName, isDisabled, options, isRequired }: BindTypeCellProps) => {
  const { t } = useTranslation()

  return (
    <FormInput
      disableClearable
      autocompleteOptions={options}
      disabled={isDisabled}
      inputType={GENERATOR_INPUT_TYPE.AUTOCOMPLETE}
      label=''
      name={fieldName}
      placeholder={t('commandParameters.inputs.type.placeholder')}
      //  rules={{ required: !!isRequired }} // временно отключена валидация WF-6931
      formInputContainerSx={{
        '& .MuiFormLabel-root': { display: 'none' },
        flexWrap: 'nowrap',
      }}
    />
  )
}
